import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectParticipantEmail } from "../../utils/types/models";

export default createEntityReducer<IProjectParticipantEmail>(Endpoint.ProjectParticipantEmails, Endpoint.ProjectParticipantEmailsList);
